import React from 'react';
import { Box, Button } from '@mui/material';

interface FloatingActionBarProps {
  show: boolean;
  awaitingDifficultySelection: boolean;
  onNewQuery: () => void;
  onGetTestPaper: () => void;
  handleGetImage: () => void;
}

const FloatingActionBar: React.FC<FloatingActionBarProps> = ({
  show,
  awaitingDifficultySelection,
  onNewQuery,
  onGetTestPaper,
  handleGetImage
}) => {
  if (!show) return null;

  return (
    <Box
      sx={{
        position: 'absolute',
        bottom: 86,
        right: 14,
        zIndex: 20,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
        gap: 0.75,
        pointerEvents: 'none',
        '& .MuiButton-root': {
          pointerEvents: 'auto',
        },
      }}
    >
      {/* New Query — secondary action */}
      <Button
        variant="outlined"
        size="small"
        onClick={onNewQuery}
        sx={{
          textTransform: 'none',
          borderColor: '#667eea',
          color: '#667eea',
          fontSize: 11,
          py: 0.5,
          px: 1.5,
          minHeight: 0,
          lineHeight: 1.6,
          borderRadius: 2,
          whiteSpace: 'nowrap',
          bgcolor: 'rgba(255,255,255,0.92)',
          backdropFilter: 'blur(4px)',
          boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
          '&:hover': {
            borderColor: '#5568d3',
            bgcolor: 'rgba(240,242,245,0.95)',
            boxShadow: '0 4px 12px rgba(0,0,0,0.12)',
          },
        }}
      >
        New Query
      </Button>
      {/* Practice Test — primary action */}
      <Button
        variant="contained"
        size="small"
        onClick={onGetTestPaper}
        disabled={awaitingDifficultySelection}
        sx={{
          textTransform: 'none',
          bgcolor: '#667eea',
          fontSize: 11,
          py: 0.5,
          px: 1.5,
          minHeight: 0,
          lineHeight: 1.6,
          borderRadius: 2,
          whiteSpace: 'nowrap',
          boxShadow: '0 2px 8px rgba(102,126,234,0.35)',
          '&:hover': {
            bgcolor: '#5568d3',
            boxShadow: '0 4px 14px rgba(102,126,234,0.45)',
          },
          '&:disabled': {
            bgcolor: '#c5cff9',
            boxShadow: 'none',
            color: '#fff',
          },
        }}
      >
        Practice Test
      </Button>

      <Button
        variant="contained"
        //   fullWidth={isMobile}
        size="small"
        onClick={handleGetImage}
        sx={{
          textTransform: 'none',
          bgcolor: '#667eea',
          fontSize: 11,
          py: 0.5,
          px: 1.5,
          minHeight: 0,
          lineHeight: 1.6,
          borderRadius: 2,
          whiteSpace: 'nowrap',
          boxShadow: '0 2px 8px rgba(102,126,234,0.35)',
          '&:hover': {
            bgcolor: '#5568d3',
            boxShadow: '0 4px 14px rgba(102,126,234,0.45)',
          },
          '&:disabled': {
            bgcolor: '#c5cff9',
            boxShadow: 'none',
            color: '#fff',
          },
        }}
      >
        Get Image
      </Button>
      {/* </Box> */}
    </Box>
  );
};

export default FloatingActionBar;